import { create } from "zustand";
import { Property } from "../domain/device/entities/properties";
import { persist } from "zustand/middleware";

interface PropertyPreferences {
  [id: number]: {
    pageSize: number;
  };
}

interface PropertyState {
  property?: Property;
  properties?: Property[];
  propertiesPreferences?: PropertyPreferences;
}

interface PropertyActions {
  setProperty: (property: Property) => void;
  setProperties: (properties: Property[]) => void;
  clearProperties: () => void;
  setPropertiesPreferences: (preferences: PropertyPreferences) => void;
  getPropertiesPreferences: () => PropertyPreferences | undefined;
  clearPropertiesPreferences: () => void;
}

export const usePropertyStore = create(
  persist<PropertyState & PropertyActions>(
    (set, get) => ({
      property: undefined,
      properties: undefined,
      propertiesPreferences: undefined,
      setProperty: (property: Property) => set({ property }),
      setProperties: (properties: Property[]) => set({ properties }),
      clearProperties: () => set({ properties: undefined, property: undefined }),
      setPropertiesPreferences: (preferences: PropertyPreferences) =>
        set({ propertiesPreferences: { ...get().propertiesPreferences, ...preferences } }),
      getPropertiesPreferences: () => get().propertiesPreferences,
      clearPropertiesPreferences: () => set({ propertiesPreferences: undefined }),
    }),
    {
      name: "property-storage",
    } 
  )
);
